import {Injectable} from '@angular/core';
import {WorkbenchPlugin, WorkbenchPluginId, WorkbenchViewConfig,} from '../../shared/types';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {Observable, of} from 'rxjs';
import {DataRepositoryViewComponent, DataRepositoryViewPayload} from './views/data-repository.component';
import {faDatabase} from '@fortawesome/pro-light-svg-icons';
import {WorkbenchCommandRegistry} from '../../shared/services/workbench-command-registry.service';

@Injectable()
export class MediaBrowserPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'media-browser';
    views: WorkbenchViewConfig<any>[];

    static readonly ViewContainerId: string = 'media-browser.viewcontainer';
    static readonly ImageBrowserViewId: string = 'media-browser.view.image.repo';
    static readonly VideoBrowserViewId: string = 'media-browser.view.video.repo';

    constructor(readonly layoutManager: WorkbenchLayoutManager,
                private readonly commandRegistry: WorkbenchCommandRegistry) {
        super(layoutManager);
        this.views = [
            {
                id: MediaBrowserPlugin.ImageBrowserViewId,
                component: DataRepositoryViewComponent,
                name: 'Image Browser',
                defaultViewContainer: MediaBrowserPlugin.ViewContainerId,
                expandedByDefault: true,
                payload: {data: {type: 'screenshot', mode: 'normal' }, callbacks: {}} as DataRepositoryViewPayload
            },
            {
                id: MediaBrowserPlugin.VideoBrowserViewId,
                component: DataRepositoryViewComponent,
                name: 'Video Browser',
                defaultViewContainer: MediaBrowserPlugin.ViewContainerId,
                expandedByDefault: true,
                payload: {data: {type: 'video', mode: 'normal'}, callbacks: {}} as DataRepositoryViewPayload
            }
        ];
    }

    onWorkbenchDestroy() {
    }

    onWorkbenchInit(): Observable<void> {
        const imageBrowserViewConfig = this.views.find(v => v.id === MediaBrowserPlugin.ImageBrowserViewId);

        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: MediaBrowserPlugin.ViewContainerId,
            name: 'Media Browser',
            icon: {
                type: 'faIcon',

                instance: faDatabase
            },
            allowedPanels: ['left-top'],
            defaultPanel: 'left-top',
            displayMode: 'stacked',
            toolbarCommandId: 'media-browser:toggleViewContainer'
        });

        this.commandRegistry.registerCommand(
            'media-browser:toggleViewContainer',
            {
                name: 'Media Browser',
                icon: {
                    type: 'faIcon',
                    instance: faDatabase,
                },
                description: 'Toggle Media Browser',
                statusBindings: {
                    'active': {
                        'type': 'store',
                        'storeKey': `viewcontainers.${MediaBrowserPlugin.ViewContainerId}.status.visible`,
                    }
                }
            },
            () => {
                this.layoutManager.toggleViewContainer(MediaBrowserPlugin.ViewContainerId, true);
            }
        );

        this.commandRegistry.registerCommand(
            'media-browser:showImageBrowserInMode',
            {},
            (params: {mode: 'normal' |'selection', callback?: (id: string, name: string) => void}) => {
                imageBrowserViewConfig.payload.data.mode = params.mode;
                if (params.callback) {
                    imageBrowserViewConfig.payload.callbacks['selected'] = params.callback;
                }
                this.layoutManager.showView(MediaBrowserPlugin.ImageBrowserViewId, false);
            }
        );

        this.commandRegistry.registerCommand(
            'media-browser:resetImageBrowserMode',
            {},
            () => {
                imageBrowserViewConfig.payload.data.mode = 'normal';
                delete imageBrowserViewConfig.payload.callbacks['selected'];
            }
        );

        return of(undefined);
    }
}
